import { Component, Inject, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { ThemePalette } from "@angular/material/core";
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogConfig as MatDialogConfig} from "@angular/material/legacy-dialog";
import * as _ from "lodash";
import { Observable, BehaviorSubject } from "rxjs";
import { MatCarouselComponent } from "@thouet/material-carousel";
import { take } from "rxjs/operators";
import { Subscription } from "rxjs";
import { Guid } from "guid-typescript";

import { AppGlobals } from "../../app.globals";
import { AlertService, MediaWatcherService } from "../../_services";
import { UnSavedChangesDialogComponent } from "../../_components/unSavedChangesDialog/unSavedChangesDialog.component";
import { ProfileImageDialogComponent } from "../profileImage";

@Component({
    templateUrl: "identityDocumentImagesDialog.component.html",
    styleUrls: ["identityDocumentImagesDialog.component.css"]
})
export class IdentityDocumentImagesDialogComponent implements OnInit, OnDestroy {
    fullName: string;
    identityDocumentImages = [];
    studentCode = null;
    newImageAdded = false;
    identityDocumentDetailsId = 0;
    isMobilePortrait = false;
    mediaWatcherSubscription: Subscription;
    isMobile = false;
    allowEdit = false;
    isPassport = false;
    selectedDocumentImage = null;
    identityDocumentRejectedReason = null;
    needsAdminReview = false;
    identityDocumentInformationNeedsReview = false;

    slidesList = null;
    color: ThemePalette = "primary";
    slideHeight = "24vh";
    slides = 0;

    @ViewChild("matCarousel") matCarousel: MatCarouselComponent;

    newIdentityDocumentImages = new BehaviorSubject<any[]>([]);
    newIdentityDocumentImages$: Observable<any> = this.newIdentityDocumentImages.asObservable();

    constructor(private dialogRef: MatDialogRef<IdentityDocumentImagesDialogComponent>, @Inject(MAT_DIALOG_DATA) data: any, public dialog: MatDialog, private appGlobals: AppGlobals,
        private alertService: AlertService, private mediaWatcherService: MediaWatcherService) {
        this.identityDocumentImages = _.cloneDeep(data.identityDocumentImages);
        this.fullName = data.fullName;
        this.studentCode = data.studentCode;
        this.identityDocumentDetailsId = data.identityDocumentDetailsId;
        this.allowEdit = data.allowEdit;
        this.isPassport = data.isPassport;
        this.identityDocumentRejectedReason = data.identityDocumentRejectedReason;
        this.needsAdminReview = data.needsAdminReview;
        this.identityDocumentInformationNeedsReview = data.identityDocumentInformationNeedsReview;
    }

    ngOnInit() {
        this.mediaWatcherSubscription = this.mediaWatcherService.isMobilePortrait.subscribe(isMobilePortrait => {
            this.isMobilePortrait = isMobilePortrait;
        });

        this.mediaWatcherSubscription = this.mediaWatcherService.isTabletLarge.subscribe(isMobile => {
            this.isMobile = isMobile;
        });

        this.newIdentityDocumentImages.next(_.orderBy(this.identityDocumentImages, "sequenceNumber"));

        this.selectedDocumentImage = this.newIdentityDocumentImages.value.filter(c => c.fileName !== "tempImage")[0];
    }

    ngOnDestroy() {
        this.newIdentityDocumentImages.unsubscribe();
    }

    close() {
        if (this.newImageAdded) {
            //show unsaved changes dialog
            const dialogConfig = new MatDialogConfig();

            dialogConfig.disableClose = true;
            dialogConfig.autoFocus = true;
            dialogConfig.closeOnNavigation = true;
            dialogConfig.width = this.isMobile ? "60vw" : "30vw";
            dialogConfig.height = "auto";
            dialogConfig.panelClass = "unSavedChanges-dialog-container";

            const dialogRef = this.dialog.open(UnSavedChangesDialogComponent, dialogConfig);

            dialogRef.afterClosed().subscribe(result => {
                if (result === "confirm") {
                    const data = {
                        newIdentityDocumentImages: [],
                        identityDocumentRejectedReason: this.identityDocumentRejectedReason
                    }

                    this.dialogRef.close(data);
                }
            });
        } else {
            this.dialogRef.close(null);
        }
    }

    addDocumentImage() {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.closeOnNavigation = true;
        dialogConfig.height = "auto";
        dialogConfig.width = this.isMobile ? "75%" : "50%";
        dialogConfig.panelClass = "profileDialogContainer";

        dialogConfig.data = {
            imageSrc: null,
            isProfileImage: false
        };

        const dialogRef = this.dialog.open(ProfileImageDialogComponent, dialogConfig);

        dialogRef.afterClosed()
            .subscribe(croppedImage => {
                if (croppedImage) {
                    this.newIdentityDocumentImages$
                        .pipe(take(1))
                        .subscribe((val: any) => {
                            const index = val.findIndex((c => c.fileName === "tempImage") as any);

                            if (index !== -1)
                                val.splice(index, 1);

                            const imageData = [...val];

                            const sequenceNumber = this.newIdentityDocumentImages.value.length > 0 ? _.maxBy(this.newIdentityDocumentImages.value, "sequenceNumber").sequenceNumber + 1 : 0;

                            var newImage = {
                                fileName: `PassportImageScan${sequenceNumber}`,
                                fileStream: croppedImage,
                                fileType: "image/png",
                                id: 0,
                                rowversion: null,
                                sequenceNumber: sequenceNumber,
                                needsStudentReview: false,
                                guid: Guid.create()
                            };

                            imageData.push(newImage);

                            this.newIdentityDocumentImages.next(_.orderBy(imageData, "sequenceNumber"));
                        });

                    this.newImageAdded = true;

                    setTimeout(() => {
                        this.matCarousel.slideTo(this.newIdentityDocumentImages.value.length - 1);
                    }, 0);
                }
            });
    }

    replaceDocumentImage() {
        if (this.allowEdit && this.selectedDocumentImage && (this.selectedDocumentImage.id === 0 || this.selectedDocumentImage.needsStudentReview || this.identityDocumentInformationNeedsReview)) {
            const dialogConfig = new MatDialogConfig();

            dialogConfig.disableClose = true;
            dialogConfig.autoFocus = true;
            dialogConfig.closeOnNavigation = true;
            dialogConfig.height = "auto";
            dialogConfig.width = this.isMobile ? "75%" : "50%";
            dialogConfig.panelClass = "profileDialogContainer";

            dialogConfig.data = {
                imageSrc: null,
                isProfileImage: false
            };

            const dialogRef = this.dialog.open(ProfileImageDialogComponent, dialogConfig);

            dialogRef.afterClosed()
                .subscribe(croppedImage => {
                    if (croppedImage) {
                        this.newIdentityDocumentImages$
                            .pipe(take(1))
                            .subscribe((val: any) => {
                                const imageData: any[] = [...val];

                                var newImage = {
                                    fileName: `PassportImageScan${this.selectedDocumentImage.sequenceNumber}`,
                                    fileStream: croppedImage,
                                    fileType: "image/png",
                                    id: 0,
                                    rowversion: null,
                                    sequenceNumber: this.selectedDocumentImage.sequenceNumber,
                                    needsStudentReview: false,
                                    guid: Guid.create()
                                };

                                var index = imageData.findIndex(((elt) => { return this.selectedDocumentImage.id === 0 ? elt.guid === this.selectedDocumentImage.guid : elt.id === this.selectedDocumentImage.id }) as any);
                                imageData.splice(index, 1);

                                imageData.push(newImage);

                                this.newIdentityDocumentImages.next(_.orderBy(imageData, "sequenceNumber"));

                                this.selectedDocumentImage = this.newIdentityDocumentImages.value[index];
                            });

                        this.newImageAdded = true;
                        this.identityDocumentRejectedReason = null;
                    }
                });
        }
    }

    saveDocumentImage() {
        const data = {
            newIdentityDocumentImages: this.newIdentityDocumentImages.value,
            identityDocumentRejectedReason: this.identityDocumentRejectedReason
        }
        this.dialogRef.close(data);
    }

    onMatCarouselSlideChange(slideNo: any) {
        this.newIdentityDocumentImages$
            .pipe(take(1))
            .subscribe((val: any) => {
                const imageData: any[] = [...val];

                this.selectedDocumentImage = imageData[slideNo];
            });
    }
}